<template>
  <div class="report-view task-time-sheet-report">
    <div class="viewEdit ttrInfo">
      <b-card class="d-flex">
        <div class="calendar justify-content-between mt-0">
          <p class="task-timesheet">
            ACL Access Log Report
          </p>
          <div id="date-select" class="d-flex justify-content-center align-items-center mr-0 calender">
            <VueDatePicker :start="startDate" :end="endDate" :active-btn="activeBtn" @date="updateDate" />
            <Help v-show="$store.state.app.userManualList" code="ACLALR" />
          </div>
        </div>
      </b-card>
      <div class="card-filter-section mt-0">
        <b-row>
          <b-col cols="8" lg="8" class="d-block d-lg-flex align-items-center justify-content-start flex-wrap"> <button
              class="back-button btn btn-secondary mr-2" @click="back()">
              <feather-icon icon="ArrowLeftIcon" width="18" height="18" />
              <span>Back</span>
            </button>
            <p class="filter-title">
              Filters:
            </p>
            <div class="">
              <custom-dropdown v-model="is_active" :options="isActiveList" :search-box="false" :hide-close="true"
                label="Active" icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="searchUser" :options="filterUserOptions" multiple label="Members"
                icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="eventMode" :options="eventModeOptions" :search-box="false" :hide-close="true"
                label="Event" icon="EditIcon" />
            </div>
            <option-drop-down v-model="perPage" />
          </b-col>
          <b-col cols="4" lg="4" class="d-flex justify-content-end">
            <button class="apply-filter filterRedesign mr-1" @click="applyFilter()">
              Apply Filter
            </button>
            <button class="apply-filter-clear filterRedesign mr-1" @click="clearFilter()">
              Clear
            </button>
          </b-col>
        </b-row>
      </div>
      <div class="report-task-section">
        <list-loader v-if="loader && reports.length == 0" :fields="tableFields" />
        <div v-else-if="reports.length">
          <div class="emp-list time-sheet-list tableDesigns">
            <b-table :items="reports" :fields="tableFields" show-empty responsive
              class="emp-list-data emp-list-report table-responsive time-sheet-report">
              <template #cell(employee_id)="data">
                <div>
                  <p v-if="data.item.employee_id" class="date">
                    {{ data.item.employee_id }}                   
                  </p>
                </div>
              </template>
              <template #cell(employee_name)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar size="30" 
                    :text="(data.item.employee_name || '').split(' ')[0] | avatarText" 
                    style="background-color: #f97753"  
                    v-if="data.item.employee_name" />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.employee_name || '-' }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(timestamp)="data">
                <div>
                  <p v-if="data.item.timestamp" class="date">
                    {{ data.item.timestamp | dateWithTimeFormat }}
                  </p>
                </div>
              </template>
              <template #cell(timestamp_utc)="data">
                <div>
                  <p v-if="data.item.timestamp_utc" class="date">
                    {{ data.item.timestamp_utc | dateWithTimeFormat }}
                  </p>
                </div>
              </template>
              <template #cell(event_name)="data">
                <div>
                  <span class="badge" :class="data.item.event === 0 ? 'badge-success' : 'badge-danger'">
                    {{ data.item.event_name || '-' }}
                  </span>
                </div>
              </template>
              <template #cell(device)="data">
                <div>
                  <p class="device-info">
                    {{ data.item.device || '-' }}
                  </p>
                </div>
              </template>
              <template #cell(device_master)="data">
                <div>
                  <p class="device-info">
                    {{ data.item.acl_device ? data.item.acl_device.name : '-' }}
                  </p>
                </div>
              </template>
            </b-table>
            <Pagination v-if="totalCount > 0" :current-page="currentPage" :per-page="perPage" :total-count="totalCount"
              class="report-pagination" @currentPage="currentPage = $event" />
          </div>
        </div>
        <div v-else class="w-100">
          <img src="@/assets/images/nodatafound/nodata.svg" alt="no-data" class="no-data-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AclAccessLogReportMixin from '../../mixin/report/AclAccessLogReport/index';
import ListLoader from '@/components/loaders/table-loading.vue'
import customDropdown from '@/components/dropdown/customDropdown.vue'
import VueDatePicker from '../../views/TaskSummary/calender.vue'

export default {
  name: 'AclAccessLogReport',
  components: {
    ListLoader,
    customDropdown,
    VueDatePicker,
  },
  mixins: [AclAccessLogReportMixin],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/component-css/approvals.css";
@import "../../assets/scss/component-css/report.css";
@import "../../assets/scss/variables/_variables.scss";
@import "../../assets/scss/component-css/clockTimesheetReport.scss";

.device-info {
  font-weight: 500;
  margin: 0;
}
.badge {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.25rem;

  &.badge-success {
    background-color: #28a745;
    color: white;
  }

  &.badge-danger {
    background-color: #dc3545;
    color: white;
  }
}
.report-view .emp-list-report .date {
  width: fit-content;
}
</style>
